"use client";

import { Component, type ErrorInfo, type ReactNode } from "react";

interface ClientFeatureErrorBoundaryProps {
	children: ReactNode;
	onError?: (error: Error, errorInfo: ErrorInfo) => void;
}

interface ClientFeatureErrorBoundaryState {
	hasError: boolean;
}

export class ClientFeatureErrorBoundary extends Component<
	ClientFeatureErrorBoundaryProps,
	ClientFeatureErrorBoundaryState
> {
	state: ClientFeatureErrorBoundaryState = {
		hasError: false,
	};

	static getDerivedStateFromError(): ClientFeatureErrorBoundaryState {
		return { hasError: true };
	}

	componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
		console.error(error, errorInfo);
		this.props.onError?.(error, errorInfo);
	}

	render(): ReactNode {
		if (this.state.hasError) {
			return null;
		}

		return this.props.children;
	}
}
